import { httpGet, httpGetFile, httpPost } from './api.service';
import { GetEquipmentRequest } from '../requestModels/getEquipmentRequest';
import { PaginatedResult } from '../types/PaginatedResult';
import { Equipment } from '../types/Equipment';
import { Result } from '../types/Result';
import { SingleResult } from '../types/SingleResult';
import { TraceInfo } from '../types/TraceInfo';

const getEquipmentById = async (id: string): Promise<SingleResult<Equipment>> => {
  return await httpGet<SingleResult<Equipment>>(`api/equipment/${id}`);
};

const getEquipmentByRefId = async (id: string): Promise<SingleResult<Equipment>> =>
  await httpGet<SingleResult<Equipment>>('api/equipment', { filters: [{ id: id }] });

const serializeFilters = (filters: any[]) => {
  return filters
    .map((f, i) => {
      let str = `filters[${i}].fieldName=${f.fieldName}&filters[${i}].fieldValue=${f.fieldValue}`;
      if (f.filterType !== undefined && f.filterType !== null) {
        str += `&filters[${i}].filterType=${f.filterType}`;
      }
      return str;
    })
    .join('&');
};
const getEquipment = async (request: GetEquipmentRequest): Promise<SingleResult<PaginatedResult<Equipment>>> => {
  // Check if we have dropdown filters (they have fieldName property)
  const hasDropdownFilters = request.filters?.some((f) => f.fieldName !== undefined);

  if (hasDropdownFilters) {
    // Use serialized format for dropdown filters
    const query = serializeFilters(request.filters || []);
    return await httpGet<SingleResult<PaginatedResult<Equipment>>>(`api/equipment?${query}&skip=${request.skip}&take=${request.take}`);
  } else {
    // Use old format for SearchBar filters
    return await httpGet<SingleResult<PaginatedResult<Equipment>>>('api/equipment', request);
  }
};

const searchSerialNumbers = async (search: string): Promise<Result<Equipment>> =>
  await httpGet<Result<Equipment>>('api/equipment/serialnumber/search/' + search);

const exportEquipment = async (request: GetEquipmentRequest): Promise<void> => {
  return await httpGetFile('api/equipment/export', request);
};

const updateEquipmentLabels = async (request: any): Promise<void> => {
  return await httpPost(`api/equipment/label`, request);
};

const getEquipmentTrace = async (wildcard: string, includeOALIndication = true): Promise<TraceInfo> => {
  const res: any = await httpGet<TraceInfo>('api/trace', { wildcard, includeOALIndication });
  return res.data;
};

export { getEquipmentById, getEquipment, searchSerialNumbers, exportEquipment, updateEquipmentLabels, getEquipmentByRefId, getEquipmentTrace };
